import { render } from "./Project.vue?vue&type=template&id=2e171092&scoped=true&lang=html&bindings={\"data\":\"props\",\"getImgUrl\":\"options\"}"
import script from "./Project.vue?vue&type=script&lang=ts"
export * from "./Project.vue?vue&type=script&lang=ts"

import "./Project.vue?vue&type=style&index=0&id=2e171092&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2e171092"

export default script